<ng-container *ngIf="current as announcement">
  <app-announcement-banner
    *ngIf="announcement.displayStyle === 'TOP_BANNER'; else modalTpl"
    [announcement]="announcement"
    (closed)="onClosed()"
  ></app-announcement-banner>
  <ng-template #modalTpl>
    <app-announcement-modal [announcement]="announcement" (closed)="onClosed()"></app-announcement-modal>
  </ng-template>
</ng-container>
